// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__37wpP","title":"ClientCherryInfo_title__2Yz0t","itemText":"ClientCherryInfo_itemText__1Bl8U"};